module.exports = __webpack_public_path__ + "img/img2.cb303da4.png";